import React, { useState } from 'react';
import {
  Box,
  Typography,
  Chip,
  Button,
  Card,
  CardContent,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  useTheme,
  useMediaQuery,
} from '@mui/material';
import { ReactComponent as FavoriteIcon } from '../assets/images/ring.svg';
import { ReactComponent as FavoriteWhite } from '../assets/images/ring_light.svg';
import HowItWorksPopup from './HowItWorksPopup';

export default function MarriagePredictionsCard() {
  const [open, setOpen] = useState(false);

  const theme = useTheme();
  const IconImage =
    theme.palette.mode === 'dark' ? FavoriteWhite : FavoriteIcon;
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  return (
    <>
      <Card
        sx={{
          borderRadius: '8px',
          border: '1px solid #ddd',
          p: isMobile ? 1 : 3,
          maxWidth: 760,
          mx: 'auto',
          boxShadow: 'none',
          backgroundColor: 'transparent',
          marginTop: '55px',
        }}
      >
        <CardContent>
          {/* Title Row */}
          <Box display="flex" alignItems="center" gap={1} mb={1}>
            <IconImage fontSize="small" />
            <Typography variant="h4" fontWeight={600}>
              Marriage Predictions
            </Typography>
            <Chip
              label="Vedic + Ai"
              size="small"
              sx={{
                backgroundColor: 'F5F5F5',
                fontWeight: 500,
                fontSize: 'clamp(8px, 1.2vw, 14px)',
                borderRadius: '6px',
              }}
            />
          </Box>

          {/* Description */}
          <Typography variant="body1" sx={{ mb: '20px', mt: '30px' }}>
            Know When You’ll Get Married Instantly with KaliyugAI
          </Typography>
          <Typography variant="body1" sx={{ mb: '20px' }}>
            Get your <strong>accurate marriage month and year</strong>{' '}
            prediction powered by advanced Vedic Astrology + AI precision.
          </Typography>
          <Typography variant="body1" sx={{ mb: '50px' }}>
            <strong>
              No vague answers because your future deserves truth not
              assumptions.
            </strong>
          </Typography>

          {/* Button Row */}
          <Box display="flex" alignItems="center" gap={1.5}>
            <Button
              variant="contained"
              size="small"
              sx={{
                textTransform: 'none',
                fontSize: 'clamp(12px, 1.8vw, 18px)',
                borderRadius: '12px',
                borderWidth: '1px',
                borderColor: '#000000',
                borderStyle: 'solid',
                backgroundColor:
                  theme.palette.mode === 'dark' ? '#bababa' : '#EFEFEF',
                color: '#454545',
                fontWeight: 600,
                boxShadow: 'none',
                textWrap: 'nowrap',
                '&:hover': {
                  backgroundColor:
                    theme.palette.mode === 'dark' ? '#a0a0a0' : '#E0E0E0',
                  boxShadow: 'none',
                },
              }}
              onClick={() => setOpen(true)}
            >
              How it Works
            </Button>
            <Typography
              variant="body2"
              sx={{ color: '#9F9F9F', fontSize: '14px' }}
            >
              Works best with accurate birth details.
            </Typography>
          </Box>

          {/* Footer Note */}
          <Box
            mt="36px"
            p={1.5}
            borderRadius={2}
            sx={{
              backgroundColor:
                theme.palette.mode === 'dark' ? '#bababa' : '#FAFAFA',
              borderColor: '#BABABA',
              borderWidth: 1,
              borderStyle: 'solid',
            }}
          >
            <Typography variant="body2" sx={{ color: '#454545' }}>
              <strong>Up next:</strong> Career, Finance, and Foreign Travel.
              Rolling out soon to complete your life blueprint.
            </Typography>
          </Box>
        </CardContent>
      </Card>

      <HowItWorksPopup open={open} onClose={() => setOpen(false)} />
    </>
  );
}
